import React, { PureComponent } from "react";
import moment from "moment";
import Slider from "react-slick";

import { formatInsightText } from "./../Utils/InsightsUtils";
import { XrayCarouselNav, trackXrayCarousel } from "./../Utils/XrayUtils";

import Logo from "./../../i/axe.svg";

class XrayInsightsSlider extends PureComponent {
  state = {
    currentSlide: 1,
  };

  render() {
    const { data } = this.props;

    const carouselPrev = () => {
      this.slider.slickPrev();
      const cs = this.state.currentSlide;
      let slideNumber = cs > 1 ? cs - 1 : data.length;

      trackXrayCarousel(
        "Xray Tooltip Insights Previous",
        "Insights",
        `${slideNumber + "/" + data.length}`,
        slideNumber
      );

      this.setState({
        currentSlide: slideNumber,
      });
    };

    const carouselNext = () => {
      this.slider.slickNext();
      const cs = this.state.currentSlide;
      let slideNumber = cs + 1 <= data.length ? cs + 1 : 1;

      trackXrayCarousel(
        "Xray Tooltip Insights Next",
        "Insights",
        `${slideNumber + "/" + data.length}`,
        slideNumber
      );

      this.setState({
        currentSlide: slideNumber,
      });
    };

    const renderInsightsSlides = () =>
      data.map((insight, i) => (
        <div className="slick-slider-container" key={i}>
          <div className="d-flex mb-1">
            <img src={Logo} alt="Pickaxe" width={14} height={12} />
            <div className="xray-tooltip__insight-date ml-2">
              {moment
                .utc(insight.insight_generation_time)
                .utc()
                .format("MM/DD/YY - hh:mm a")}
            </div>
          </div>
          <div className={"insight__text"}>
            <span
              dangerouslySetInnerHTML={{
                __html: formatInsightText(
                  insight.insight_markup_array,
                  insight.insight_text_markup
                ),
              }}
            />
          </div>
        </div>
      ));

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true,
      onInit: () => {
        // Track the initial slide
        trackXrayCarousel(
          "Xray Tooltip Insights Next",
          "Insights",
          `{1 + "/" + data.length}`,
          1
        );
      },
    };

    return (
      <div className="tooltip-slider pb-2">
        <div className="standard-tooltip__section-header mb-3 mt-3">
          Insights
        </div>
        <Slider {...settings} ref={(c) => (this.slider = c)}>
          {renderInsightsSlides()}
        </Slider>
        {data.length > 1 && (
          <XrayCarouselNav
            slide={this.state.currentSlide}
            data={data}
            next={(e) => carouselNext(e)}
            prev={(e) => carouselPrev(e)}
          />
        )}
      </div>
    );
  }
}
export default XrayInsightsSlider;
